import { RegionInfoDto } from '@sr/dto';
import { regionListApi } from 'entities/geo/regions/hook/apiSlice';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import useConfirmDialog from './confirm-dialog.hook';
import { useSnack } from 'shared/ui/snack';

interface UseRegionsListResult {
  collection: RegionInfoDto[];
  isLoading: boolean;
  error: string;
}

export const useRegionsList = (filter?: URLSearchParams): UseRegionsListResult => {
  const { data: regions, isLoading, error } = regionListApi.useGetRegionsListQuery(   
    { filter: filter?.toString() || '' },
    { refetchOnMountOrArgChange: true }
  );

  return {
    collection: regions || [], 
    error: extractNestJsErrorMessage(error),
    isLoading,
  };
};

export const useDeleteRegion = () => {
  const showConfirmDialog = useConfirmDialog();
  const { showSuccess, showError } = useSnack();

  const [deleteRegion] = regionListApi.useDeleteRegionMutation();

  return (region: RegionInfoDto) => {
    showConfirmDialog({
      content: `Удалить регион ${region?.name}?`
    })
      .then(() => deleteRegion(region.id).unwrap())
      .then(() => showSuccess('Регион успешно удален'))
      .catch((e) => showError('Ошибка удаления региона', e));
  };
}